import Resources from './views/resources'
import Monitoring from './views/monitoring'
import Plans from './views/plans'
import ApplyVoucher from './views/apply-voucher'
import CustomerSettings from './views/customer-settings'
import ConfirmCode from './views/confirm-code'
import Services from './views/services'
import NotificationChannels from './views/notifications'
import NotFoundPage from './views/not-found'
import Subscription from './views/subscription'
import Subscriptions from './views/billings'
import PaymentMethods from './views/payment-methods'
import Automations from './views/automations'
import AutomationDesigner from './views/automation-designer'
import Members from './views/members'
import Jobs from './views/jobs'
import Job from './views/job'
import Teams from './views/teams'
import Integrations from './views/integrations'
import ResourceIntegrations from './views/resource-integrations'
import RedeemCoupon from './views/redeem-coupon'
import Statuspages from './views/statuspages'
import StatuspageSubscriptions from './views/statuspages/Subscriptions'
import CreateEditStatuspage from './views/statuspages/CreateEditStatuspage'
import Incidents from './views/incidents'
import Rulesets from './views/rulesets'
import OnCallScheduling from './views/on-call-scheduling'
import CreateEditRuleset from './views/rulesets/CreateEditRuleset'
import ServerMonitoring from './views/server-monitoring'
import CreateEditServerResource from './views/server-monitoring/CreateEditServerResource'
import Usage from './views/usage'
import ServerResourceDashboard from './views/server-monitoring/ServerResourceDashboard'
import JobEvents from './views/jobEvents'
import LogsDashboard from './views/logs-dashboard'
import LogGroupsList from './views/log-groups'
import PhoneCalls from './views/phone-calls'
import i18next from 'i18next'
import {stripLangPrefix} from './utils/navigation'
import {envConfig} from './utils/env'
import CreateEditPhoneCall from './views/create-edit-phone-call'
import Security from './views/security'

const {isPaymentEnabled, isSelfHosted} = envConfig

const routeItem = (titleKey, basePath, component) => {
    return {
        getTitle: () => {
            return i18next.t(titleKey, {ns: 'titles'})
        },
        paths: [`/:lang${basePath}`, basePath],
        component,
        isSame(path) {
            return stripLangPrefix(path) === basePath
        },
        containsId(path) {
            const segments = stripLangPrefix(path).split('/')
            const expectedBase = basePath.split('/')[1]

            return segments[1] === expectedBase &&
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(segments[2])
        }
    }
}

const routes = {
    resources: routeItem('ping_home_console_resources', '/', Resources),
    server_monitoring: routeItem('ping_home_console_server_monitoring', '/server-monitoring', ServerMonitoring),
    server_resource: routeItem('ping_home_console_server_monitoring', '/server-monitoring/:id', ServerResourceDashboard),
    create_server_monitoring: routeItem('ping_home_console_create_server_monitoring', '/server-monitoring/create', CreateEditServerResource),
    update_server_monitoring: routeItem('ping_home_console_update_server_monitoring', '/server-monitoring/update/:id', CreateEditServerResource),
    monitoring: routeItem('ping_home_console_monitoring', '/monitoring/:id', Monitoring),
    log_groups_list: routeItem('ping_home_console_log_groups_list', '/log-groups/', LogGroupsList),
    logs_dashboard: routeItem('ping_home_console_logs', '/logs/', LogsDashboard),
    plans: routeItem('ping_home_console_plans', '/plans/', Plans),
    usage: routeItem('ping_home_console_usage', '/usage/', Usage),
    apply_voucher: routeItem('ping_home_console_apply_voucher', '/apply-voucher', ApplyVoucher),
    redeem_coupon: isPaymentEnabled && routeItem('ping_home_console_redeem_coupon', '/redeem-coupon', RedeemCoupon),
    settings: routeItem('ping_home_console_settings', '/customer-settings', CustomerSettings),
    security: routeItem('ping_home_console_security', '/security', Security),
    confirm_code: routeItem('ping_home_console_confirm_code', '/confirm-code', ConfirmCode),
    services: routeItem('ping_home_console_services', '/services', Services),
    notifications: routeItem('ping_home_console_personal_channels', '/notifications/personal', NotificationChannels),
    integrations: routeItem('ping_home_console_integrations', '/integrations', Integrations),
    oauth_integration: routeItem('ping_home_console_integrations', '/integration/oauth/authorize', Integrations),
    resource_integrations: routeItem('ping_home_console_resource_integrations', '/resource/:id/integrations', ResourceIntegrations),
    team_channels: routeItem('ping_home_console_team_channels', '/notifications/team', NotificationChannels),
    subscription_success: isPaymentEnabled && routeItem('ping_home_console_subscription', '/subscription/success', Subscription),
    subscription_cancel: isPaymentEnabled && routeItem('ping_home_console_subscription', '/subscription/cancel', Subscription),
    subscription_update_success: isPaymentEnabled && routeItem('ping_home_console_subscription', '/subscription/update/success', Subscription),
    subscription_update_cancel: isPaymentEnabled && routeItem('ping_home_console_subscription', '/subscription/update/cancel', Subscription),
    subscriptions: isPaymentEnabled && routeItem('ping_home_console_subscriptions', '/subscriptions', Subscriptions),
    payment_methods: isPaymentEnabled && routeItem('ping_home_console_payment_methods', '/payment-methods', PaymentMethods),
    teams: routeItem('ping_home_console_teams', '/teams', Teams),
    members: routeItem('ping_home_console_members', `/teams/:teamId/members`, Members),
    automations: !isSelfHosted && routeItem('ping_home_console_automations', '/automation', Automations),
    automation_designer: routeItem('ping_home_console_automation_designer', '/automation/:id/designer', AutomationDesigner),
    jobs: routeItem('ping_home_console_jobs', '/jobs', Jobs),
    job_events: routeItem('ping_home_console_job_events', '/events', JobEvents),
    job: routeItem('ping_home_console_heartbeats', '/jobs/:id', Job),
    statuspages: routeItem('ping_home_console_statuspages', '/status-pages', Statuspages),
    statuspage_subscriptions: routeItem('ping_home_console_statuspage_subscriptions', '/status-page-subscriptions', StatuspageSubscriptions),
    create_statuspage: routeItem('ping_home_console_create_statuspage', '/status-pages/create', CreateEditStatuspage),
    update_statuspage: routeItem('ping_home_console_update_statuspage', '/status-pages/:id', CreateEditStatuspage),
    incidents: routeItem('ping_home_console_incidents', '/incidents', Incidents),
    rulesets: routeItem('ping_home_console_rulesets', '/rulesets', Rulesets),
    create_ruleset: routeItem('ping_home_console_create_ruleset', '/rulesets/create', CreateEditRuleset),
    update_ruleset: routeItem('ping_home_console_update_ruleset', '/rulesets/:id', CreateEditRuleset),
    not_found: routeItem('ping_home_console_not_found', '/not-found', NotFoundPage),
    on_call_scheduling:  routeItem('ping_home_on_call_scheduling', '/on-call-scheduling', OnCallScheduling),
    phone_calls: routeItem('ping_home_phone_calls', '/phone-calls', PhoneCalls),
    create_phone_call: routeItem('ping_home__create_phone_call', '/phone-calls/create', CreateEditPhoneCall),
    update_phone_call: routeItem('ping_home_phone_calls', '/phone-calls/:id', CreateEditPhoneCall),
    unhandled_route: routeItem('ping_home_console_not_found', '/*', NotFoundPage)

}

const routeArr = Object.values(routes).filter(Boolean)

export {
    routes,
    routeArr
}
